import { FETCH_USERS, FETCH_USER } from "../types";
import fetchService from "../../../services/fetchService";

const baseUrl = {
  backend: process.env.API_BASE_URL,
};

export const fetchUsersData = () => async (dispatch) =>
  await dispatch({
    type: FETCH_USERS,
    message: `All users data`,
    payload: fetchService(`${baseUrl.backend}/api/users`),
  });

export const fetchUserData = (id) => async (dispatch) =>
  await dispatch({
    type: FETCH_USER,
    message: `All user data`,
    payload: fetchService(`${baseUrl.backend}/api/users/${id}`),
  });
